var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-inputs" },
    [
      _c("div", { staticClass: "notice-box" }, [
        _vm._v(
          "Das Antragsportal wurde vorzeitig geschlossen, da die Mittel aufgrund der Anzahl an Anträgen bereits ausgeschöpft sind."
        )
      ]),
      _vm.inputsToken
        ? [
            _c("p", { staticClass: "my-1" }, [
              _vm._v(
                "Bitte beachten Sie, dass eine Zwischenspeicherung Ihrer eingegebenen Daten nicht möglich ist! Die Eingabe Ihrer Daten sowie das Hochladen der erforderlichen Nachweise muss in einem Schritt erfolgen und endet mit dem Schritt „Antrag absenden“."
              )
            ]),
            _c("p", { staticClass: "mb-3" }, [
              _vm._v(
                "Berücksichtigen Sie bitte auch, dass es gerade zu Beginn des Stipendienprogramms zu längeren Bearbeitungszeiten kommen kann."
              )
            ]),
            _c(
              "v-stepper",
              {
                model: {
                  value: _vm.step,
                  callback: function($$v) {
                    _vm.step = $$v
                  },
                  expression: "step"
                }
              },
              [
                _c(
                  "v-stepper-header",
                  [
                    _c(
                      "v-stepper-step",
                      {
                        attrs: { complete: "", step: "1" },
                        on: {
                          click: function($event) {
                            return _vm.onSelectStep(1)
                          }
                        }
                      },
                      [_vm._v("Daten erfassen")]
                    ),
                    _c(
                      "v-stepper-step",
                      {
                        attrs: { complete: _vm.completedStep >= 1, step: "2" }
                      },
                      [_vm._v("Antragsdaten prüfen")]
                    ),
                    _c(
                      "v-stepper-step",
                      {
                        attrs: { step: "3", complete: _vm.completedStep >= 2 }
                      },
                      [_vm._v("Abschluss")]
                    )
                  ],
                  1
                ),
                _c(
                  "v-stepper-items",
                  [
                    _c(
                      "v-stepper-content",
                      { staticClass: "pa-0", attrs: { step: "1" } },
                      [
                        _c("input-data", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.step === 1,
                              expression: "step === 1"
                            }
                          ],
                          ref: "input-data",
                          staticClass: "mt-8",
                          on: {
                            next: function($event) {
                              return _vm.onNextStep(1)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-stepper-content",
                      { staticClass: "pa-0", attrs: { step: "2" } },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "hint-label font-weight-bold mt-3 mb-2"
                          },
                          [_vm._v("Achtung:")]
                        ),
                        _c("p", { staticClass: "hint-label mb-0" }, [
                          _vm._v(
                            'Bitte prüfen Sie in der nachfolgenden Übersicht Ihre angegebenen Daten sorgfältig auf Korrektheit. Um Änderungen vorzunehmen, gelangen Sie mit einem Klick auf die orange Schaltfläche "Daten erfassen" zurück zur Datenerfassung.'
                          )
                        ]),
                        _vm.step === 2
                          ? _c("check-data", {
                              staticClass: "mt-8",
                              on: {
                                next: function($event) {
                                  return _vm.onNextStep(2)
                                },
                                "file-error": _vm.onFileError
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "v-stepper-content",
                      { staticClass: "pa-0", attrs: { step: "3" } },
                      [
                        _vm.step === 3
                          ? _c("thank-you", { staticClass: "mt-8" })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }